import { formatSeasonRange, inferSeasonStartFromEnd } from './formatSeasonDate';

export function seasonWindowCopy({
  status,
  startsAt,
  endsAt,
  language,
}: {
  status: string;
  startsAt?: string | null;
  endsAt?: string | null;
  language: string;
}): { key: string; values?: Record<string, string> } | null {
  const { start, end } = formatSeasonRange({
    startsAt: startsAt ?? inferSeasonStartFromEnd(endsAt),
    endsAt,
    language,
  });
  const isActive = status === 'active';

  if (start && end) {
    return {
      key: isActive ? 'ranks.seasonActiveRange' : 'ranks.seasonEndedRange',
      values: { start, end },
    };
  }

  if (end) {
    return {
      key: isActive ? 'ranks.seasonActiveUntil' : 'ranks.seasonEndedOn',
      values: { date: end },
    };
  }

  if (isActive) {
    return { key: 'ranks.seasonActive' };
  }

  return null;
}
